import React from 'react';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
export default function VersionMismatchError(props) {
  return (
    <div id="version-mismatch-error-main-container" className="mainContainer">
      <div id="version-mismatch-error-inner-container" className="innerContainer">
        <div
          id="version-mismatch-error-login"
          className="login flex-y-center flex-column"
        >
          <div
            id="version-mismatch-error-login-form"
            className="loginForm flex-y-center flex-column"
            style={{ padding: '24px' }}
          >
            <div
              id="version-mismatch-error-login-header"
              className="loginHeading flex-y-center"
            >
              <div id="version-mismatch-error-icon">
                <RMSvgIcon
                  id="version-mismatch-error-icon-rm-logo"
                  name="RMLogo"
                  height={48}
                  width={48}
                />
              </div>
              <div
                id="version-mismatch-error-license-wrapper"
                style={{ marginLeft: 16, paddingBottom: 5 }}
              >
                <div
                  id="version-mismatch-error-license-header-1"
                  className="license-header"
                >
                  ROCK MAKER
                  <span
                    id="version-mismatch-error-registered-logo"
                    className="registeredLogo"
                  >
                    &#174;
                  </span>
                </div>
                <div
                  id="version-mismatch-error-license-header-2"
                  className="license-header2"
                >
                  Crystallization Software
                </div>
              </div>
            </div>

            <div
              id="version-mismatch-error-license-style"
              style={{ width: '100%', alignSelf: 'flex-start' }}
            >
              <div
                id="version-mismatch-error-license-content"
                className="license-header"
                style={{ alignSelf: 'start', margin: 12 }}
              >
                ROCK MAKER cannot continue because database and application versions do
                not match.
                <p style={{ marginTop: 12 }}>
                  Rock Maker: {props.location?.state?.RMVersion}
                  <br />
                  Database: {props.location?.state?.dbVersion}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
